<template>
  <basicContainer>
    <div class="loadingContainer" v-if="loadingContainer.remind">
      <div class="loadingContainer_icon">
        <i class="el-icon-loading loadingContainer_icon_loading" v-if="loadingContainer.remind === '表单页面加载中。。。'" />
        <i class="el-icon-error loadingContainer_icon_error" v-else />
      </div>
      <div class="loadingContainer_remind">
        <p>{{loadingContainer.remind}}</p>
      </div>
    </div>
    <div v-else>
      <div ref="viewForm" style="height: calc(100vh - 145px);margin-right:-20px">
        <!-- 顶部的一些按钮-->
        <el-container>
          <el-header style="height:auto">
            <h1 class="top-title">
              <i class="fa fa-table" aria-hidden="true"></i>
              {{viewFormData.options.tableComment}}
            </h1>
            <div :class="{'card-container':true,'levitate':true,'levitate0':true}">
              <div class="buttom-group">
                <el-button size="medium" type="primary" @click="handleSave">保存 (特权更新)</el-button>
                <el-button size="medium" type="danger" @click="$router.go(-1)">返回</el-button>
              </div>
            </div>
          </el-header>
          <el-main style="overflow-y:auto;height:calc(100vh - 195px)">
            <div :class="{'card-container':true,'card-container-2':true,'fold':fold,'sidebar-mode':sidebarMode}">

              <avue-form ref="avueform" class="preview-form bold_input" :option="viewFormData.options"
                v-model="viewFormData.modelData" :upload-after="uploadAfter" :upload-before="uploadBefore"
                :upload-preview="uploadPreview" :upload-delete="uploadDelete">
              </avue-form>
            </div>
          </el-main>
        </el-container>
      </div>
    </div>
  </basicContainer>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import { HandleForm } from '@/workFlow/utils/flowUtils'
import { loadJs, havaCustomFunction } from '@/workFlow/utils/flowUtils'

export default {
  data() {
    return {
      viewFormData: {
        // 流程状态详情
        ProcessState: 'unknownState',
        // 操作类型
        pageKey: 'DO',
        // 表单的数据
        modelData: {},
        // 表单的配置
        options: {},
        keyInfo: {
          processInstanceId: '',
          formId: '',
          businessKey: ''
        },
        // 会签控制
        sign: {
          // 是否会签模式
          isSign: false,
          // 会签数据
          signData: {}
        }
      },
      // 加载容器控制器
      loadingContainer: {
        remind: '表单页面加载中。。。'
      },
      editArray: []

    }
  },
  components: {

  },
  created() {
    let { processInstanceId, businessKey, editArray = [] } = this.$route.query

    if (!processInstanceId) {
      this.loadingContainer.remind = '缺少 processInstanceId 、businessKey'
      return
    } else {
      this.viewFormData.keyInfo.processInstanceId = processInstanceId
      this.viewFormData.keyInfo.businessKey = businessKey
      this.editArray = editArray
      // 加载一些配置
      this.getFormId(this.viewFormData.keyInfo.processInstanceId, () => {
        this.getFormModelDetail(() => {
          this.getFormInstance(() => {
            this.loadingContainer.remind = ''
            let flowControllData = this.viewFormData.options.column.filter(item => item.display).map(item => {
              if (this.editArray.includes(item.prop)) {
                return {
                  id: item.prop,
                  writable: true
                }
              } else {
                return {
                  id: item.prop,
                  writable: false
                }
              }
            })
            // 处理表单
            HandleForm.bind(this, this.viewFormData.options.column, flowControllData)()
            this.Initialize()
          })
        })
      })
    }
  },
  computed: {
    ...mapGetters(['screen'])
  },
  methods: {
    forceUpdate() {
      try {
        this.$refs.avueform && this.$refs.avueform.$forceUpdate()
      } catch (error) {
        console.error(error)
      }
    },
    /**
     * 由于prop中的数据传递有可能异步,故mounted 、 created
     * 对组件数据初始化可能存在问题，所以这里进行初始化
     */
    Initialize() {
      // 加载js
      if (this.viewFormData.options.jsPath) {
        loadJs(this.viewFormData.options.jsPath, () => {
          if (havaCustomFunction('init')) {
            window.workFlow['init'].bind(this, this.viewFormData.options, this.viewFormData.modelData)()
          }
        })
      }

      // 判断执行设备是否支持
      let performEquipment = this.viewFormData.options.performEquipment
      if (performEquipment === 'mobile') {
        this.$router.push({
          path: '/workflow/tips',
          query: {
            tips: '暂不支持PC端办理。'
          }
        })
      }
      // 设置页面title
      // TODO: 判断服务器是否返回
      document.title = this.viewFormData.modelData.businessDataTitle ? this.viewFormData.modelData.businessDataTitle : null || this.viewFormData.options.tableComment
    },
    /**
     * 根据流程实例ID获取表单ID
     * @param {String} processInstanceId 流程实例ID
     * @param {Function} callback  回调函数,callback参数为formId
     */
    getFormId(processInstanceId, callback) {
      this.$http.get('/flow-ext/process-form-key', {
        params: {
          processInstanceId
        }
      }).then(response => {
        this.viewFormData.keyInfo.formId = response.data
        typeof callback === 'function' && callback()
      }).catch(error => {
        this.loadingContainer.remind = error.msg || error.message
      })
    },
    getFormModelDetail(callback) {
      this.$http.get(`/form-model/detail?formId=${this.viewFormData.keyInfo.formId}`).then(response => {
        this.viewFormData.options = response.data.modelJson
        typeof callback === 'function' && callback()
      }).catch(error => {
        this.loadingContainer.remind = error.msg || error.message
      })
    },
    getFormInstance(callback) {
      this.$http('/form-instance/select', {
        params: {
          dataId: this.viewFormData.keyInfo.businessKey,
          formId: this.viewFormData.keyInfo.formId
        }
      }).then(response => {
        this.viewFormData.modelData = response.data
        typeof callback === 'function' && callback()
      }).catch(error => {
        this.loadingContainer.remind = error.msg || error.message
      })
    },
    uploadDelete(column, file, callback) {
      // avue2.5.2 删除逻辑自带的，2.6.1以后界面删了，保存数据后再次进入还在，固加了该删除逻辑，后续版本升级要格外注意---不靠谱的avue
      let files = this.viewFormData.modelData[column.prop]
      files.splice(parseInt(file.uid), 1)
    },

    /**
     * 查看前的回调
     */
    uploadPreview(file, column, callback) {
      let fileData = this.viewFormData.modelData[column.prop][parseInt(file.uid)]

      if (fileData.fileContentType.startsWith('image/')) {
        // 如果是图片、视频格式的附件，则使用avue自带的弹窗进行预览。
        return this.$ImagePreview([{ url: file.url, thumbUrl: file.url }], 0)
      } else if (fileData.fileContentType === 'application/pdf') {
        window.open(file.url, '_blank')
      } else {
        this.$downloadFile.get('/common/document/download', {
          params: {
            fileName: file.name,
            fileUniqueCode: fileData.fileUniqueCode,
            doDownload: true
          }
        }).then(_ => { }).catch(error => {
          this.$message.error(`加载文件失败..${error.msg || error.message}`)
        })
      }
      // 其他附件 直接打开新窗口
      // window.open(file.url, '_blank', 'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=1268, height=720')
    },

    /**
     *  上传文件后回调函数
     */
    uploadAfter(response, done, loading, column) {
      /**
         * 这一步 上传附件成功,但是获取不到附件的文件名  后端不填坑,前端胡乱填
         * 该坑描述: 附件系统上传成功后只返回 fileUniqueCode 未返回文件名
         * 其他地方同样需要文件名去解析文件流。前端文件上传avue解析不到文件名。所以界面无法显示上传附件的名称。
         * 上一任代码主解决办法 @author HL: 在 column 中定义变量,然后一系列违规操作,人工处理上传后的参数
         * 本次处理方案: 只有后端返回 200 均视为成功, 然后通过setTimeout手动寻找fileUniqueCode,修改其文件名。
         */
      if (response.fileUniqueCode) {
        let modelData = this.viewFormData.modelData
        done()
        setTimeout(() => {
          if (modelData[column.prop] instanceof Array) {
            modelData[column.prop].forEach(item => {
              if (item.value === response.fileUniqueCode) {
                let { fileUniqueCode, fileName, fastDFSGroupName, fastDFSPath, fileSize, fileContentType, fastDFSThumbImagePath } = response
                this.$set(item, 'label', fileName)
                this.$set(item, 'fileUniqueCode', fileUniqueCode)
                this.$set(item, 'fileSize', fileSize)
                this.$set(item, 'fileContentType', fileContentType)
                this.$set(item, 'value', `/${fastDFSGroupName}/${fastDFSPath}`)
                this.$set(item, 'fastDFSThumbImagePath', fileContentType.startsWith('image/') ? `/${fastDFSGroupName}/${fastDFSThumbImagePath}` : null)
              }
            })
          }
        }, 0)
      } else {
        this.$message.error(`附件上传失败,失败原因:${response.msg || response}`)
        loading()
      }
    },
    /**
     * 上传图片前 类型识别
     */
    uploadBefore(file, done, loading, column) {
      /**
       * 1、文档[doc、docx、xls、xlsx、ppt、pptx、txt、pdf、md];
       *  2、图片[jpg、jpeg、png、gif、bmp];
       * 3、视频[avi、mov、rmvb、rm、flv、mp4];
       * 4、压缩包[rar、zip];
       */
      let fileArr = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'pdf', 'md', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'avi', 'mov', 'rmvb', 'rm', 'flv', 'mp4', 'rar', 'zip']
      let segs = file.name.split('.')
      if (segs.length <= 1) {
        return this.$message.error('识别文件类型失败,请检查上传的文件类型') && loading()
      }
      if (fileArr.includes(segs.pop())) {
        done()
      } else {
        this.$message.error('文件格式不支持')
        loading()
      }
    },
    /**
     * @auth ZHJI --
     * 保存
     */
    handleSave() {
      this.specialValueCommitConversion()
      this.$http.post(`/form-instance/save?formId=${this.viewFormData.keyInfo.formId}`, Object.assign(this.viewFormData.modelData, this.viewFormData.keyInfo)).then(response => {
        this.$message.success(response.msg)
      }).catch(error => {
        this.$message.error(error.msg || error.message)
      })
    },
    specialValueCommitConversion() {
      /** 用户选择器格式转换 */
      let flowUserChooseDeal = item => {
        if (item.type === 'flowUserChoose') {
          let oldVal = this.viewFormData.modelData[item.prop]
          if (oldVal && Array.isArray(oldVal) && oldVal.length && item.callIdName) {
            this.viewFormData.modelData[`$${item.callIdName}`] = oldVal.map(item => item.name).toString()
            let id = oldVal.map(item => item.id)
            this.viewFormData.modelData[item.callIdName] = item.maxRows === 1 ? id.toString() : id
          } else {
            this.viewFormData.modelData[`$${item.callIdName}`] = ''
            this.viewFormData.modelData[`${item.callIdName}`] = item.maxRows === 1 ? '' : []
          }
        }
      }
      this.viewFormData.options.column.forEach(item => {
        flowUserChooseDeal(item)
      })
      if (this.viewFormData.options.group) {
        this.viewFormData.options.group.forEach(groupItem => {
          groupItem.column.forEach(item => {
            flowUserChooseDeal(item)
          })
        })
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.loadingContainer {
  width: 500px;
  margin: 0 auto;
  padding: 5px 0;
  color: rgb(59, 156, 217);
  text-align: center;
  font-weight: 600;
  &_icon {
    font-size: 25px;
    &_error {
      color: red;
    }
  }
  &_remind {
    p {
      margin: 0;
      width: 100%;
    }
  }
}
</style>

<style lang="scss" scoped>
.buttom-group {
  height: 36px;
  text-align: right;
}

.card-container {
  &-2 {
    margin-top: 15px;
  }
}

/** 表单标题 */

.drawer-top {
  height: 30px;
  line-height: 30px;
  text-align: center;
}

:deep(.preview-form) {
  padding-top: 20px;
  padding-bottom: 20px;
}

:deep(.avue-crud) {
  padding-bottom: 18px;
}

.bold_input :deep(.el-input__inner) {
  font-weight: bolder !important;
}

:deep(.el-textarea__inner) {
  font-weight: bolder !important;
}
</style>

<style lang="scss" scoped>
// 顶部的标题
h1.top-title {
  margin: 0;
  float: left;
  font-size: 20px;
  font-weight: 400;
  line-height: 36px;
  color: #409eff;
}

// 悬浮按钮样式
.levitate {
  margin-left: -20px;
  padding-bottom: 20px;
  padding-right: 20px;
  border-bottom: 10px solid #f0f2f5;
  margin-left: -40px;
  margin-right: -20px;
}

.levitate0 {
  background: #fff;
} // 侧边栏布局样式
.sidebar {
  & > div {
    min-height: 75vh; // padding-left: 10px;
    padding: 10px 10px;
    background: #f7f8fa;
    border-left: 1px solid #e4e7ec;
    border-bottom: 1px solid #e4e7ec;
    :deep(.avue-form) {
      .avue-form__group {
        background: #f7f8fa;
      }
      .avue-form__row {
        width: 100%;
        & > div {
          display: flex;
          flex-direction: column;
          .el-form-item__content {
            margin-left: 0 !important;
          }
          .el-form-item__label {
            text-align: left;
            width: 100% !important;
          }
        }
      }
    }
  }
}

.fold {
  .sidebar {
    width: 50px !important;
  }
} // 顶部菜单切换布局
.mainlayout {
  height: calc(100vh - 205px) !important; // padding-top:75px
}

.card-container-2 {
  margin-top: 0;
  height: 100%;
  overflow-y: auto;
  :deep(.el-card__body) {
    padding-right: 0;
  }
}

:deep(.preview-form) {
  overflow: unset;
  height: auto;
}

:deep(.flow-user-choose) {
  background: #fff !important;
}

@media screen and (max-width: 992px) {
  .levitate {
    left: 5px;
    right: 12px;
    top: 78px !important;
  }
}
</style>

